import React, { Component } from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import Pdf from "react-to-pdf";
import { PDFExport } from '@progress/kendo-react-pdf';
import $ from 'jquery';
import { slide as Menu } from 'react-burger-menu';
import { ToastContainer, toast, cssTransition } from "react-toastify";
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import ReactTable from "react-table-6";
import "react-table-6/react-table.css";
import MyAccount from './MyAccount';
import logout from '../login/Logout';
import "@syncfusion/ej2-base/styles/material.css";
import "@syncfusion/ej2-react-buttons/styles/material.css";
import "@syncfusion/ej2-react-popups/styles/material.css";
import Loader from 'react-loader-spinner';

const monthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
];
const Fade = cssTransition({
    enter: 'fadeIn',
    exit: 'fadeOut',
});
const ref = React.createRef();
const options = {
    orientation: 'landscape',
    unit: 'in',
    format: [4, 2]
};


ToastContainer.defaultProps.transition = Fade;
ToastContainer.defaultProps.autoClose = 1500;
const closeAllMenusOnEsc = (e) => {
    if (document.getElementsByClassName("bm-menu-wrap")[0].style.transform == "translate3d(-100%, 0px, 0px)") {
        document.getElementsByClassName("bm-menu-wrap")[0].style.transform = 'translate3d(-200%, 0, 0)';
    }
    this.setState({ areMenusOpen: false });

};

class ManagePro extends Component {
    pdfExportComponent;
    constructor() {
        super(...arguments);
        this.dialogClose = () => {
            this.setState({
                hideDeletePopup: false, showTicketStatusPopup: false, hideDialog: false,
                hideLogoutConfirmation: false, showTicketStatusOpenPopup: false,
            });
        };

        this.settings = { effect: 'Zoom', duration: 400, delay: 0 };
        this.Okbutton = [{
            buttonModel: {
                content: 'OK',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.dialogInstance.hide();
                this.setState({ createNewProjectPage: false });
                this.setState({ hideCommentAddedDialog: false });
                this.setState({ hideTicketGenerateDialog: false });
            }
        }],
            this.createProjectbutton = [{
                buttonModel: {
                    content: 'OK',
                    cssClass: 'e-flat',
                    isPrimary: true,
                },
                'click': () => {
                    this.state.createNewProjectPage = false;
                    this.props.history.push('/project-plan-settings');
                }
            }],
            this.buttons = [{
                buttonModel: {
                    content: 'Yes',
                    cssClass: 'e-flat',
                    isPrimary: true,

                },
                'click': props => {
                    this.deleteProjectApi(this.state.id)
                }
            }
                , {
                buttonModel: {
                    content: 'No',
                    cssClass: 'e-flat',
                    isPrimary: true,
                },
                'click': () => {
                    this.setState({ hideDeletePopup: false });
                }
            }],
            this.ticketStatusButton = [{
                buttonModel: {
                    content: 'Yes',
                    cssClass: 'e-flat',
                    isPrimary: true,

                },
                'click': props => {
                    this.updateTicketStatusApi(this.state.editedId, this.state.ticketDescription,
                        this.state.ticketPriority, this.state.ticketStatus, this.state.ticketType,
                        this.state.ticketTitle)
                }
            }
                , {
                buttonModel: {
                    content: 'No',
                    cssClass: 'e-flat',
                    isPrimary: true,
                },
                'click': () => {
                    this.setState({ hideDeletePopup: false, showTicketStatusOpenPopup: false, showTicketStatusPopup: false });
                }
            }];

        this.deleteSuccessbuttons = [{
            buttonModel: {
                content: 'Ok',
                cssClass: 'e-flat',
                isPrimary: true,

            },
            'click': props => {
                this.setState({ hideDeleteSuccessPopup: false });
            }
        }];

        this.logoutButton = [{
            buttonModel: {
                content: 'Yes',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': (props) => {
                logout();
            }
        },
        {
            buttonModel: {
                content: 'No',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.setState({ hideLogoutConfirmation: false });
            }
        }];

        this.state = {
            data: [{
                domain: '',
                id: '',
                language: [],
                lastBuildTime: '',
                lastModifiedBy: '',
                lastModifiedDate: '',
                name: '',
                projectDescription: ''

            }],
            ticketData: [{
                title: '',
                description: '',
                ticketStatus: '',
                ticketPriority: '',
                ticketType: '',
                id: ''

            }],
            ticketInfo: [{
                ticketId: '',
                commentedByUserId: '',
                commentedByUserName: '',
                commentedByUserEmail: '',
                comment: '',
                commentType: '',
                commentTime: '',

            }],
            editedProjectId: "-1",
            dataUrl: '',
            fields: {},
            errors: {},
            languages: [],
            domains: [],
            dataFields: { text: 'name', value: 'code' },
            domainData: { text: 'name', value: 'code' },
            deletePropIndex: '',
            propsId: '',
            editedId: '-1',
            editImageSrc: './assets/images/edit.svg',
            contentEditable: "false",
            showStore: false,
            hideDialog: false,
            hideDeletePopup: false,
            hideDeleteSuccessPopup: false,
            showTicketStatusOpenPopup: false,
            hideTicketGenerateDialog: false,
            showManageProjectStore: false,
            showCreateProjectPage: false,
            showRaiseTicketEditPage: false,
            showInvoiceManagePage: false,
            ticketTitle: '',
            ticketDescription: '',
            ticketFileName: '',
            ticketFileType: '',
            ticketImageFile: '',
            ticketPriority: '',
            ticketStatus: '',
            ticketType: '',
            lastModifiedDate: '',
            ticketCreatedDate: '',
            lastModifiedBy: '',
            showCreateProjectPage: false,
            showRaiseTicketEditPage: false,
            showInvoiceManagePage: false,
            ticketTitle: '',
            ticketDescription: '',
            ticketFileName: '',
            ticketFileType: '',
            ticketImageFile: '',
            ticketPriority: '',
            ticketStatus: '',
            ticketType: '',
            lastModifiedDate: '',
            createdDate: '',
            lastModifiedBy: '',
            selectedFile: null,
            imagePreviewUrl: null,
            isOpen: false,
            dataUrl: null,
            currentLogoId: '',
            result: null,
            hideDialog: false,
            hideCommentAddedDialog: false,
            showRaiseTicketPage: false,
            showPreviousTicketPage: false,
            showTicketStatusPopup: false,
            showMyAcountPopUp: false,
            hideLogoutConfirmation: false,
            invoices: [],
            invoiceSubtotal: "",
            invoiceGst: "",
            invoiceProjectname: "",
            displayInvoice: false,
            billingFromDate: "",
            billingToDate: "",
            billingAmount: "",
            editedInvoiceId: "1e349120-aba0-11ea-87fb-1da1e01b7a49",
            Date: "",
            walletBalance: 0,
            successResp: false,
            currentProject: {}
        }
        this.createdDate = '';
        this.domainVar = [],
            this.statusVar = [],
            this.editImageSrc = "./assets/images/edit2.png";
        this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
        this.escFunction = this.escFunction.bind(this);
    }


    createNewProjectPage = (e) => {
        this.setState({ showManageProjectStore: false, showCreateProjectPage: true });


    }

    notifySuccess(Projectkey) {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;{Projectkey}</b>, {
            position: "top-center"
        });
    }

    notifyEmptyFields() {
        toast.dismiss();
        toast(<b>Please fill all fields</b>, {
            position: "top-center",


        });
    }
    notifyEmptyCommentField() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />&nbsp;&nbsp;Please enter your comment before submitting</b>, {
            position: "top-center",


        });
    }
    notifyFailToCreate(falseRes) {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>{falseRes}</b>, {
            position: "top-center",
            color: "red"

        });
    }

    nullValuePopup() {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>Oops! Error occurred. Please try again</b>, {
            position: "top-center",
            color: "red"

        });
    }

    showManageInvoice = () => {
        this.fetchInvoiceApi();
        this.fetchWalletBalanceApi();
        this.fetchPaymentpropertyApi();
        var today = new Date();
        var d = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mmm = monthNames[d.getMonth()];
        var yyyy = today.getFullYear();

        today = dd + ' ' + mmm + ' ' + yyyy;


        this.setState({ showInvoiceManagePage: true, Date: today })
    }

    updateTicketStatusApi = (ticketid, description,
        ticketPriority, ticketStatus, ticketType, title) => {
        var thisController = this;
        var statusChanged = (ticketStatus === "OPEN") ? "CLOSED" : "OPEN";
        var updatedData = {
            "userId": JSON.parse(localStorage.getItem("user_details"))["userId"],
            "projectId": localStorage.getItem("currentProjectId"),
            description: description,
            id: ticketid,

            ticketPriority: ticketPriority,
            ticketStatus: statusChanged,
            ticketType: ticketType,
            title: title,
        }

        $.ajax({
            url: "/api/generate-ticket",
            async: false,
            method: 'PATCH',
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token"),
                'Content-Type': 'application/json'
            },
            data: JSON.stringify(updatedData),
            processData: false,
            contentType: "application/json; charset=UTF-8",
            success: function (res) {
                if (res.success === true) {
                    thisController.setState({ showTicketStatusOpenPopup: false, showTicketStatusPopup: false });
                    thisController.notifySuccess("Ticket status Updated Successfully");
                    thisController.fetchTicketDataApi();

                } else if (res.success === false && res.result.includes("null")) {
                    thisController.nullValuePopup();

                } else {
                    thisController.notifyFailToCreate(res.result);


                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/sales-desk/";
                }
            }

        })

    }
    escFunction(event) {
        if (event.keyCode === 27) {
            if (this.state.showManageProjectStore === true && this.state.hideDeletePopup === false) {
                this.setState({ showManageProjectStore: false });
            }
            if (this.state.showCreateProjectPage === true) {
                this.setState({ showCreateProjectPage: false, showManageProjectStore: true });
            }
            if (this.state.showPreviousTicketPage === true) {
                this.setState({ showPreviousTicketPage: false });
            }
            if (this.state.showRaiseTicketPage === true) {
                this.setState({ showRaiseTicketPage: false, showPreviousTicketPage: true });
            }
            if (this.state.showInvoiceManagePage === true) {
                this.setState({ showInvoiceManagePage: false });
            }
            if (this.state.hideDeletePopup === true) {
                this.setState({ hideDeletePopup: false });
            }
            if (this.state.showMyAcountPopUp) {
                this.setState({ showMyAcountPopUp: false })
            }
        }
    }

    notifyWarning = (message) => {
        toast.dismiss();
        toast(<b>{message}</b>, {
            position: "top-center",
        });
    }

    validateTemplateProject = () => {
        if (this.state.currentProject.isAnApp != null && this.state.currentProject.isAnApp) {
            this.notifyWarning("Can't able to delete client bot");
            return false;
        } else {
            return true;
        }
    }
    deleteProjectApi = (propsIndex) => {
        let deleteProjectController = this.state.data;
        var deleteConstructorVariables = this;
        var id = deleteConstructorVariables.state.currentProject.id;
        $.ajax({
            url: "/api/project/" + id,
            async: false,
            method: 'DELETE',
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
            success: function (res) {

                if (res.success === true) {
                    deleteConstructorVariables.state.hideDeletePopup = false;
                    deleteConstructorVariables.fetchDataApi();
                    deleteConstructorVariables.notifySuccess("Project deleted successfully");
                    deleteConstructorVariables.setState(deleteConstructorVariables.state)


                } else if (res.success === false && res.result.includes("null")) {
                    deleteConstructorVariables.nullValuePopup();

                } else {
                    deleteConstructorVariables.notifyFailToCreate(res.result);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/sales-desk/";
                }
            }

        });

    }

    markAsBeingEdited(id) {
        this.setState({ editedProjectId: id })
    }
    fetchCommentsApi(ticketCommentId) {
        var thisController = this;

        $.ajax({
            url: "/api/ticket-comments",
            async: false,
            method: 'GET',
            data: { "userId": JSON.parse(localStorage.getItem("user_details"))["userId"], "projectId": localStorage.getItem("currentProjectId"), ticketId: ticketCommentId },
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
            success: function (res) {
                if (res.success === true) {
                    console.clear();

                    for (var i = 0; i < res.result.length; i++) {
                        if (res.result[i]['commentTime'] == 0) {
                            res.result[i]['commentTime'] = thisController.createdDate;
                        } else if (res.result[i]['commentTime'] != '0' && res.result[i]['commentTime'] != null) {
                            var date = new Date(res.result[i]['commentTime']);
                            res.result[i]['commentTime'] = date.toLocaleString();
                        }
                    }

                    thisController.setState({ ticketInfo: res.result });

                } else if (res.success === false && res.result.includes("null")) {
                    thisController.nullValuePopup();

                } else {
                    thisController.notifyFailToCreate(res.result);


                }


            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/sales-desk/";
                }
            }
        });
    }



    fetchTicketDataApi() {
        var thisController = this;
        $.ajax({
            url: "/api/generate-ticket",
            async: false,
            method: 'GET',
            data: {
                "userId": JSON.parse(localStorage.getItem("user_details"))["userId"],
                "projectId": localStorage.getItem("currentProjectId"), "showClosed": document.getElementById("Ticket-status-drop-down").value
            },
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
            success: function (res) {
                if (res.success === true && res.result.length !== 0) {
                    var ticketInfo = res.result;
                    var fullPath = res.result[0].ticketFileName;
                    var filename = fullPath.replace(/^.*[\\\/]/, '');
                    var date = new Date(res.result[res.result.length - 1].lastModifiedDate);
                    var date1 = new Date(res.result[0].createdDate);
                    thisController.setState({
                        ticketData: res.result,
                        editedId: res.result[0].id, ticketTitle: res.result[0].title,
                        ticketDescription: res.result[0].description,
                        ticketStatus: res.result[0].ticketStatus,
                        ticketType: res.result[0].ticketType,
                        ticketPriority: res.result[0].ticketPriority,
                        lastModifiedDate: date.toLocaleString(),
                        ticketFileName: filename

                    });

                    thisController.createdDate = date1.toLocaleString();
                    thisController.fetchCommentsApi(res.result[0].id);

                } else if (res.success === true && res.result.length == 0) {
                    thisController.setState({
                        ticketData: [{
                            title: '',
                            description: '',
                            ticketStatus: '',
                            ticketPriority: '',
                            ticketType: '',
                            id: ''

                        }],
                        ticketInfo: [{
                            ticketId: '',
                            commentedByUserId: '',
                            commentedByUserName: '',
                            commentedByUserEmail: '',
                            comment: '',
                            commentType: '',
                            commentTime: '',

                        }],
                        editedId: '-1', ticketTitle: '',
                        ticketDescription: '',
                        ticketStatus: '',
                        ticketType: '',
                        ticketPriority: '',
                        lastModifiedDate: '',
                        ticketFileName: ''


                    });
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/sales-desk/";
                }
            }
        });
    }


    validateCells(name, projectDescription) {
        if (name == "" || projectDescription == "") {
            this.notifyEmptyFields();
            return false;
        } else {
            return true;
        }

    }
    validateTicketFields(title, description) {
        if (title == "" || description == "") {
            this.notifyEmptyFields();
            return false;
        } else {
            return true;
        }

    }
    saveTicketCell(props, e) {

    }

    validateProjectDescription(projectDescription) {
        if (projectDescription != "") {
            return true;
        } else {
            return false;
        }
    }
    saveProjectApi(props, e) {
        var manageProjectController = this;

        props.original.name = document.getElementById("projectName1" + props.index).innerText.trim();
        props.original.projectDescription = document.getElementById("projectDescription1" + props.index).innerText.trim();
        props.original.domain = document.getElementById("domainOption1" + props.index).innerText.trim();
        manageProjectController.setState(this.state);
        var validateResult = this.validateCells(props.original.name, props.original.projectDescription);

        if (validateResult === true) {
            var updatedData = {
                "userId": JSON.parse(localStorage.getItem("user_details"))["userId"],
                name: props.original.name,
                projectDescription: props.original.projectDescription,
                domain: props.original.domain,
                id: props.original.id
            };

            $.ajax({
                url: "/api/project",
                async: false,
                method: 'PATCH',
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': 'application/json'
                },
                data: JSON.stringify(updatedData),
                processData: false,
                contentType: "application/json; charset=UTF-8",
                success: function (res) {
                    if (res.success === true) {
                        manageProjectController.notifySuccess(updatedData.name + " Updated Successfully");
                        manageProjectController.fetchDataApi();
                        manageProjectController.setState({ editedProjectId: "-1" });
                    } else if (res.success === false && res.result.includes("null")) {
                        manageProjectController.nullValuePopup();

                    } else {
                        manageProjectController.notifyFailToCreate(res.result);


                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/sales-desk/";
                    }
                }

            });
        } else {
            manageProjectController.setState({ editedProjectId: props.original.id });
        }
    }



    editTicketCell(props, e) {
        var fullPath = props.original.ticketFileName;
        var filename = fullPath.replace(/^.*[\\\/]/, '');
        var date = new Date(props.original.lastModifiedDate);
        this.setState({
            editedId: props.original.id, ticketTitle: props.original.title,
            ticketDescription: props.original.description,
            ticketStatus: props.original.ticketStatus,
            ticketType: props.original.ticketType,
            ticketPriority: props.original.ticketPriority,
            lastModifiedDate: date.toLocaleString(),
            ticketFileName: filename,
        });
        this.fetchCommentsApi(props.original.id);

    }

    editCell(props, e) {

        this.markAsBeingEdited(props.original.id);
    }

    showManageProjectPage = (projectId) => {

        this.getDomain();
        this.props.history.push({
            pathname: '/manage-projects',
            projectData: {
                projectId: projectId
            }
        });
    }
    showStatusClosePopup = () => {
        if (this.state.ticketStatus == "OPEN") {
            this.setState({ showTicketStatusPopup: true });
        } else {
            this.setState({ showTicketStatusOpenPopup: true })
        }

    }
    refreshProjectData = () => {
        this.fetchDataApi();
        this.setState({ editedProjectId: '-1' })
    }

    closeManageProjectPage = () => {
        this.setState({ showManageProjectStore: false })
        this.setState({ editedProjectId: '-1' })
    }
    closePreviousTicketPage = () => {
        this.setState({ showPreviousTicketPage: false });
    }
    closeCreateProjectPage = () => {
        this.fetchDataApi();
        this.setState({ showCreateProjectPage: false, showManageProjectStore: true, errors: {} })

    }
    closeRaiseTicketPage = () => {
        this.fetchTicketDataApi();
        this.setState({ showRaiseTicketPage: false, showPreviousTicketPage: true });
    }

    closeInvoiceManagePage = () => {
        this.setState({ showInvoiceManagePage: false })
    }
    cancel = () => {
        this.setState({ showCreateProjectPage: false });
    }
    handlechange = (event) => {
        localStorage.setItem("currentProjectId", document.getElementById("projectDropdown").value);
        localStorage.setItem("currentProjectName", event.target.options[event.target.selectedIndex].innerHTML);
        document.dispatchEvent(new CustomEvent("projectChanged", {
            projectId: document.getElementById("projectDropdown").value
        }));
    }
    /*Create New Project Form Functionalities*/

    statushandlechange = (event) => {
        this.fetchTicketDataApi();
    }

    handleChangeLanguage = (e) => {
        var options = e.target.options;
        var value = [];
        for (var i = 0, l = options.length; i < l; i++) {
            if (options[i].selected) {
                value.push(options[i].value);
            }
        }
        this.props.someCallback(value);
    }



    handleChange = (e) => {
        let fields = this.state.fields;
        fields[e.target.name] = e.target.value;
        this.setState({
            fields
        });

    }
    validateName = (e) => {
        let fields = this.state.fields;
        let errors = {};
        if (!fields["projectname"]) {
            errors["projectname"] = "*Please Enter your project name";
        }
        this.setState({
            errors: errors
        });

    }
    validateDescription = (e) => {
        let fields = this.state.fields;
        let errors = {};
        if (!fields["description"]) {

            errors["description"] = "*Please Enter description"

        }
        this.setState({
            errors: errors
        });

    }
    validateDomain = (e) => {
        let fields = this.state.fields;
        let errors = {};
        if (document.getElementById('domain').ej2_instances[0].value == null) {
            errors["domain"] = "Please select the domain"
        }
        this.setState({
            errors: errors
        });

    }
    validateLanguage = (e) => {
        let fields = this.state.fields;
        let errors = {};
        if (document.getElementById('language').ej2_instances[0].value == null) {

            errors["language"] = "Please select the languages"
        }
        this.setState({
            errors: errors
        });

    }
    validateAllFields = (e) => {
        e.preventDefault();
        if (this.validateForm()) {

        }
    }

    onTitleHandleChange(event) {
        this.state.ticketTitle = event.target.value;
        this.setState(
            this.state);


    }
    onTicketDescriptionHandleChange = (event) => {
        this.state.ticketDescription = event.target.value;
        this.setState(this.state);

    }
    moveToPlansPage = (projectId) => {
        this.props.history.push({
            pathname: '/project-plan-settings',
            projectData: {
                projectId: projectId
            }
        });
        localStorage.setItem("manageProjectaPathVariable", projectId)
    }
    moveToConversationalAI = () => {
        window.location.href = window.origin + "/sales-desk/projectmgmt";
    }
    moveToAksharPlatform = () => {
        window.location.href = window.origin + "/sales-desk/cloud-akshar";
    }
    moveToNLPPlatform = () => {
        window.location.href = window.origin + "/sales-desk/cloud-nlp";
    }
    moveToSpeechPlatform = () => {
        window.location.href = window.origin + "/sales-desk/cloud-asr";
    }
    moveToTtsPlatform = () => {
        window.location.href = window.origin + "/sales-desk/cloud-tts";
    }
    createNewProject = (e) => {
        this.props.history.push('/projects/createNewProject');
    }
    validateForm() {
        let fields = this.state.fields;
        let errors = {};
        let formIsValid = true;

        if (!fields["projectname"]) {
            formIsValid = false;
            errors["projectname"] = "*Please Enter your project name"

        }
        if (!fields["description"]) {
            formIsValid = false;
            errors["description"] = "*Please Enter description"

        }
        if (document.getElementById('domain') != null) {
            if (document.getElementById('domain').ej2_instances[0].value == null) {
                formIsValid = false;
                errors["domain"] = "Please select the domain"
            }
        }
        this.setState({
            errors: errors
        });
        return formIsValid;
    }
    /*END Of Create New Project Form Functionalities*/
    NotifyNoPlanSelected(result) {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />&nbsp;&nbsp;{result}</b>, {
            position: "top-center"
        });

    }
    getSelectedProjectPlan() {
        var projectPlanController = this;
        $.ajax({
            url: "/api/project-plan-details",
            async: false,
            method: 'GET',
            data: {
                "projectId": localStorage.getItem("currentProjectId")
            },
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
            success: function (res) {
                if (res.success === true) {
                    if (res.result === null) {
                        projectPlanController.NotifyNoPlanSelected("Please select plan before proceeding further");
                        var projectPlanTimer = setInterval(function () {
                            clearTimeout(projectPlanTimer);
                            projectPlanController.moveToPlansPage(localStorage.getItem("currentProjectId"));
                        }, 3000);
                    }
                } else if (res.success === false && res.result.includes("null")) {
                    projectPlanController.nullValuePopup();

                } else {
                    projectPlanController.notifyFailToCreate(res.result);
                }
            },
            error: function (xhr, status, error) {
                var errorMessage = xhr.status + ': ' + xhr.statusText
                if (xhr.status == 401) {
                    window.location.href = "/sales-desk/";
                }
            }
        });

    }

    /*Create New Project Page*/

    getDomain() {
        var domainDropDownController = this;
        $.ajax({
            url: "/api/global-domains",
            async: false,
            method: 'GET',
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token")
            },
            success: function (res) {
                if (res.success === true) {
                    var domains = res.result;
                    domainDropDownController.setState({
                        domains: domains
                    });
                    domainDropDownController.state.data.domains = domains;
                    var numberOfDomains = domains.length;

                    domainDropDownController.domainVar = [];
                    for (var i = 0; i < numberOfDomains; i++) {
                        domainDropDownController.domainVar[i] = domains[i]['code'];
                    }
                } else if (res.success === false && res.result.includes("null")) {
                    domainDropDownController.nullValuePopup();

                } else {
                    domainDropDownController.notifyFailToCreate(res.result);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/sales-desk/";
                }
            }
        });
    }


    /*Raise Ticket Fuctionalities*/
    fetchTicketStatusApi() {
        var ticketStatusController = this;
        $.ajax({
            url: "/api/ticket-status",
            async: false,
            method: 'GET',
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token")
            },
            success: function (res) {
                if (res.success === true) {
                    var ticketStatus = res.result;
                    var ele3 = document.getElementById('Ticket-status');
                    if (ele3 != null) {
                        ele3.innerHTML = null;
                        for (var i = 0; i < ticketStatus.length; i++) {
                            ele3.innerHTML = ele3.innerHTML + '<option value="' + ticketStatus[i]['key'] + '">' + ticketStatus[i]['value'] + '</option>';
                            ticketStatusController.statusVar = ticketStatus[i]['key'];

                        }
                    }
                } else if (res.success === false && res.result.includes("null")) {
                    ticketStatusController.nullValuePopup();

                } else {
                    ticketStatusController.notifyFailToCreate(res.result);
                }
            },
            error: function (xhr, status, error) {
                var errorMessage = xhr.status + ': ' + xhr.statusText
                if (xhr.status == 401) {
                    window.location.href = "/sales-desk/";
                }
            }
        });
    }
    fetchTicketTypeApi() {
        var ticketController = this;
        $.ajax({
            url: "/api/ticket-types",
            async: false,
            method: 'GET',
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token")
            },
            success: function (res) {
                if (res.success === true) {
                    var ticketTypes = res.result;
                    var ele3 = document.getElementById('Ticket-type');
                    if (ele3 != null) {
                        ele3.innerHTML = null;
                        for (var i = 0; i < ticketTypes.length; i++) {
                            ele3.innerHTML = ele3.innerHTML + '<option value="' + ticketTypes[i]['key'] + '">' + ticketTypes[i]['value'] + '</option>';

                        }
                    }
                } else if (res.success === false && res.result.includes("null")) {
                    ticketController.nullValuePopup();

                } else {
                    ticketController.notifyFailToCreate(res.result);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/sales-desk/";
                }
            }
        });
    }
    fetchTicketPriority() {
        var thisController = this;
        $.ajax({
            url: "/api/ticket-priority",
            async: false,
            method: 'GET',
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token")
            },
            success: function (res) {
                if (res.success === true) {
                    var ticketPriority = res.result;
                    var ele3 = document.getElementById('Ticket-priority');
                    if (ele3 != null) {
                        ele3.innerHTML = null;
                        for (var i = 0; i < ticketPriority.length; i++) {
                            ele3.innerHTML = ele3.innerHTML + '<option value="' + ticketPriority[i]['key'] + '">' + ticketPriority[i]['value'] + '</option>';

                        }
                    }
                } else if (res.success === false && res.result.includes("null")) {
                    thisController.nullValuePopup();

                } else {
                    thisController.notifyFailToCreate(res.result);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/sales-desk/";
                }
            }
        });
    }
    ticketimagePreviewDataUrl(event) {

        let reader = new FileReader();

        reader.onloadend = () => {
            this.setState({
                dataUrl: reader.result
            });

        }
        reader.readAsDataURL(event.target.files[0])
    }

    ticketfileChangedHandler = event => {
        this.ticketimagePreviewDataUrl(event);

        var imagePath = document.getElementById("inputFile1").value;
        const fi = document.getElementById('inputFile1');
        var imagetype = imagePath.split('.')[1];
        var allowedExtensions = /(\.jpg\.png)$/i;
        /* Check if any file is selected */
        if (fi.files.length > 0) {
            for (var i = 0; i <= fi.files.length - 1; i++) {

                const fsize = fi.files.item(i).size;
                const file = Math.round((fsize / 1024));
                if (file >= 4096) {
                }
            }

            this.setState({
                selectedFile: event.target.files[0]
            })

            let reader = new FileReader();

            reader.onloadend = () => {
                this.setState({
                    imagePreviewUrl: reader.result
                });


            }

            reader.readAsBinaryString(event.target.files[0]);

        }

    }



    submit = () => {
        var ticketController = this;
        var imagePath = document.getElementById("inputFile1").value;
        var imagetype = imagePath.split('.')[1];
        var imageUrl = this.state.imagePreviewUrl;
        var imagePath = document.getElementById("inputFile1").value;
        var imagetype = imagePath.split('.')[1];
        var allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif|\.svg)$/i;
        var title = document.getElementById("title").value;
        var description = document.getElementById("description").value;
        var validateResult = this.validateTicketFields(title, description);
        if (validateResult == true) {
            var ticketData = {

                projectId: localStorage.getItem("currentProjectId"),
                title: document.getElementById("title").value,
                description: document.getElementById("description").value,
                ticketStatus: document.getElementById("Ticket-status").value,
                ticketPriority: document.getElementById("Ticket-priority").value,
                ticketType: document.getElementById("Ticket-type").value,
                ticketFileName: imagePath,
                ticketFileType: imagetype,
                ticketImageFile: btoa(imageUrl),

            }
            $.ajax({
                url: "/api/generate-ticket",
                async: false,
                method: 'POST',
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': 'application/json'
                },
                data: JSON.stringify(ticketData),
                processData: false,
                contentType: "application/json; charset=UTF-8",
                success: function (res) {
                    if (res.success === true) {
                        ticketController.notifySuccess(ticketData.title + " generated successfully");

                        ticketController.fetchTicketDataApi();
                        ticketController.setState({ showRaiseTicketPage: false, showPreviousTicketPage: true });
                        document.getElementById("title").value = "";
                        document.getElementById("description").value = "";
                        document.getElementById("inputFile1").value = "";
                    } else if (res.success === false && res.result.includes("null")) {
                        ticketController.nullValuePopup();

                    } else {
                        ticketController.notifyFailToCreate(res.result);


                    }

                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/sales-desk/";
                    }
                }

            })
        }
    }
    showRaiseTicket = () => {
        this.setState({ showPreviousTicketPage: false, showRaiseTicketPage: true });
    }
    showPreviousRaiseTicket = () => {
        $("#raise-ticket").addClass('active-dhee-console-link');
        $("#read-doc").removeClass('active-dhee-console-link');
        this.fetchTicketStatusApi();
        this.fetchTicketTypeApi();
        this.fetchTicketPriority();
        this.fetchTicketDataApi();
        this.setState({ showPreviousTicketPage: true });

    }
    saveTicketCommentsApi = () => {
        var ticketController = this;
        if (document.getElementById("comment").value.trim() == "") {
            ticketController.notifyEmptyCommentField();
        } else {
            var ticketCommentData = {
                commentedByUserId: JSON.parse(localStorage.getItem("user_details"))["userId"],
                comment: document.getElementById("comment").value.trim(),
                ticketId: this.state.editedId,
                projectId: localStorage.getItem("currentProjectId"),

            };

            $.ajax({
                url: "/api/ticket-comments",
                async: false,
                method: 'POST',
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': 'application/json'
                },
                data: JSON.stringify(ticketCommentData),
                processData: false,
                contentType: "application/json; charset=UTF-8",
                success: function (res) {
                    if (res.success === true) {
                        ticketController.notifySuccess("Comment added successfully");
                        ticketController.fetchCommentsApi(ticketCommentData.ticketId);

                        document.getElementById("comment").value = "";


                    } else if (res.success === false && res.result.includes("null")) {
                        ticketController.nullValuePopup();

                    } else {
                        ticketController.notifyFailToCreate(res.result);
                    }
                },
                error: function (xhr, status, error) {
                    var errorMessage = xhr.status + ': ' + xhr.statusText
                    if (xhr.status == 401) {
                        window.location.href = "/sales-desk/";
                    }
                }
            });
        }
    }

    showMyAcount = () => {
        this.setState({ showMyAcountPopUp: true });
    }

    closeMyAccountPage = () => {
        this.setState({ showMyAcountPopUp: false });
    }

    /*End of Raise Ticket*/
    routeToHelpPage = () => {
        $("#read-doc").addClass('active-dhee-console-link');
        $("#raise-ticket").removeClass('active-dhee-console-link');
        window.open("https://readme.dhee.ai/", "_blank")
    }

    /*Invoice and Payment Api Calls*/
    saveInvoice(props, e) {

    }
    nullResultValuePopup() {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>Oops! Error occurred. Please try again</b>, {
            position: "top-center",
            color: "red"

        });
    }
    notifyFailToDisplay(falseRes) {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>{falseRes}</b>, {
            position: "top-center",
            color: "red"

        });
    }
    invoiceInfo(props, e) {

        this.setState({
            editedInvoiceId: props.original.id,
            billingFromDate: props.original.billingFromDate,
            billingToDate: props.original.billingToDate,
            billingAmount: props.original.billingAmount,
            invoiceGst: (props.original.billingAmount != "" && props.original.billingAmount != 0) ? Math.abs((props.original.billingAmount * 18) / 100) : "",
            invoiceSubtotal: (props.original.billingAmount != "" && props.original.billingAmount != 0) ? props.original.billingAmount - Math.abs((props.original.billingAmount * 18) / 100) : "",
            paymentRecieved: props.original.paymentReceived,
            paymentId: props.original.paymentId,
        });
        this.fetchInvoiceListApi(props.original.id);
    }
    fetchInvoiceListApi(invoiceRowId) {
        var invoiceController = this;

        $.ajax({
            url: "/api/invoice-item",
            async: false,
            method: 'GET',
            data: { "invoiceId": invoiceRowId },
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
            success: function (res) {
                if (res.success === true) {
                    var invoiceList = res.result;
                    if (res.result.length != 0) {
                        if (document.getElementById("invoice-List") != null) {
                            var ele1 = document.getElementById("invoice-List");
                            ele1.innerHTML = null;
                            ele1.innerHTML = ele1.innerHTML + "<tr><th>Name</th><th>Description</th><th>Rate</th><th>Units</th><th>Item Price</th>";
                            for (var i = 0; i < res.result.length; i++) {
                                ele1.innerHTML = ele1.innerHTML + "<tr><td>" + res.result[i]["name"] + "</td><td>" + res.result[i]["description"] + "</td><td>" + res.result[i]["rate"] + "</td><td>" + res.result[i]["units"] + "</td><td>" + res.result[i]["itemPrice"] + "</td>"
                            }
                            invoiceController.state.invoiceProjectname = res.result[0].name;
                            invoiceController.setState(invoiceController);


                        }
                    } else if (res.result.length === 0) {
                        if (document.getElementById("invoice-List") != null) {
                            var ele1 = document.getElementById("invoice-List");
                            ele1.innerHTML = null;
                            invoiceController.state.invoiceProjectname = "";
                            invoiceController.setState(invoiceController);

                        }
                    } else {
                        invoiceController.notifyFailToCreate(res.result);
                    }

                }


            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/sales-desk/";
                }
            }
        });

    }
    fetchWalletBalanceApi() {
        var invoiceController = this;
        $.ajax({
            url: "/api/get-wallet-amount",
            async: false,
            method: 'GET',
            data: { "developerId": JSON.parse(localStorage.getItem("user_details"))["userId"] },
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
            success: function (res) {
                if (res.success === true) {

                    invoiceController.state.walletBalance = res.result.walletBalance;
                    invoiceController.setState(invoiceController);


                }



            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/sales-desk/";
                }
            }
        });
    }

    fetchInvoiceApi() {
        var invoiceController = this;

        $.ajax({
            url: "/api/invoice",
            async: false,
            method: 'GET',
            data: { "userId": JSON.parse(localStorage.getItem("user_details"))["userId"] },
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
            success: function (res) {
                if (res.success === true) {
                    if (res.result.length !== 0) {
                        for (var i = 0; i < res.result.length; i++) {
                            var date = new Date(res.result[i].billingFromDate);
                            var d1 = new Date(res.result[i].billingFromDate);
                            var dd = String(date.getDate()).padStart(2, '0');
                            var mmm = monthNames[d1.getMonth()];
                            var yyyy = date.getFullYear();
                            var date1 = new Date(res.result[i].billingToDate);
                            var d2 = new Date(res.result[i].billingToDate);
                            var dd1 = String(date1.getDate()).padStart(2, '0');
                            var mmm1 = monthNames[d2.getMonth()];
                            var yyyy1 = date1.getFullYear();
                            res.result[i].billingFromDate = dd + ' ' + mmm + ' ' + yyyy;
                            res.result[i].billingToDate = dd1 + ' ' + mmm1 + ' ' + yyyy1;
                        }
                        invoiceController.state.invoices = res.result;
                        invoiceController.state.displayInvoice = true;
                        invoiceController.state.editedInvoiceId = res.result[0].id;
                        invoiceController.state.billingFromDate = res.result[0].billingFromDate;
                        invoiceController.state.billingToDate = res.result[0].billingToDate;
                        invoiceController.state.billingAmount = res.result[0].billingAmount;
                        if (res.result[0].billingAmount != "" && res.result[0].billingAmount != 0) {
                            invoiceController.state.invoiceGst = Math.abs((res.result[0].billingAmount * 18) / 100);
                            invoiceController.state.invoiceSubtotal = invoiceController.state.billingAmount - invoiceController.state.invoiceGst;
                        }
                        invoiceController.state.paymentRecieved = res.result[0].paymentReceived;
                        invoiceController.state.paymentId = res.result[0].paymentId;
                        invoiceController.setState(invoiceController);
                        invoiceController.fetchInvoiceListApi(res.result[0].id);
                    } else if (res.result.length === 0) {
                        invoiceController.setState({ displayInvoice: false })
                    }
                } else if (res.success === false && res.result === null) {
                    invoiceController.nullResultValuePopup();
                } else {
                    invoiceController.notifyFailToDisplay(res.result);
                }


            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/sales-desk/";
                }
            }
        });
    }

    fetchLanguageApi() {
        var thisController = this;
        $.ajax({
            url: "/api/languages",
            async: false,
            method: 'GET',
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
            success: function (res) {
                if (res.success === true) {
                    var languages = res.result;
                    thisController.setState({
                        languages: languages
                    });
                }
            }
        });
    }

    fetchDataApi = () => {
        var projectController = this;
        $.ajax({
            url: "/api/project",
            async: false,
            method: 'GET',
            data: { "userId": JSON.parse(localStorage.getItem("user_details"))["userId"] },
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
            success: function (res) {
                if (res.success === true) {
                    var messages = res.result;
                    projectController.setState({
                        data: messages,
                        successResp: true,
                        disabled: false,
                    })
                }
            },
        });
    }


    componentDidMount() {
        var currentUrl = window.location.href;
        if (currentUrl.includes("/sales-desk/projectmgmt")) {
            $("#social-sales-desk").addClass('active-dhee-console-link');
        } 

        setTimeout(() => {
            this.fetchDataApi();
            this.fetchLanguageApi();
        }, 300);

        document.addEventListener("keydown", this.escFunction, false);
    }

    componentWillUnmount() {

        document.removeEventListener("keydown", this.escFunction, false);

    }

    routeToInvoicePage = () => {
        this.props.history.push('/invoice');
    }

    deleteSelectedProject = (e, props) => {
        this.state.currentProject = props.original;
        if (this.validateTemplateProject()) {
            this.state.hideDeletePopup = true;
            this.state.deletePropIndex = props.index;
        }
        this.setState(this.state);
    }

    render() {
        const { data } = this.state;

        return (
            <div>
                <Loader
                    type="TailSpin"
                    color="#282a65"
                    visible={this.state.successResp ? false : true}
                    height={300}
                    width={50}
                    style={{ textAlign: 'center', marginTop: window.innerHeight / 6 + "px" }}
                />
                <div style={{ display: this.state.successResp ? 'block' : 'none' }}>

                    <div className="wrapper" id="wrap">

                        {/*links for css files used for popup */}
                        <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />
                        <link href="assets/css/ej2-base.css" rel="stylesheet" />
                        <link href="assets/images/edit.svg" rel="stylesheet" />
                        <link href="assets/images/add.svg" rel="stylesheet" />
                        <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
                        <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
                        <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
                        <link href="assets/css/screenResolution.css" rel="stylesheet" />
                        <link href="assets/css/menu-drop-down.css" rel="stylesheet" />
                        <link href="StyleSheet.css" rel="stylesheet" type="text/css" media="only screen" />
                        <link href="MobileStyleSheet.css" rel="stylesheet" type="text/css" media="only screen and (max-device-width: 480px) , only screen and (-webkit-min-device-pixel-ratio: 2) , screen and (-webkit-device-pixel-ratio:1.5)" />
                        <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
                        <link rel="stylesheet" type="text/css" href="//netdna.bootstrapcdn.com/bootstrap/3.1.1/css/bootstrap.min.css" />
                        <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                        <link href="assets/css/menu-items.css" rel="stylesheet" />
                        <link href="assets/css/horizantal-line.css" rel="stylesheet" />
                        {/* Theme style */}
                        <link rel="stylesheet" href="assets/css/adminlte.css" />
                        <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
                        <link rel="stylesheet" href="plugins/select2/select2.min.css" />
                        <link rel="stylesheet" href="assets/css/ReactToastify.css" />
                        <link rel="stylesheet" href="assets/css/drop-down-alignment.css" />
                        <link rel="stylesheet" href="plugins/select2/css/select2.min.css" />
                        {/*links from create new project */}
                        <link rel="stylesheet" href="assets/css/select2.min.css" />
                        <link rel="stylesheet" href="assets/css/flaticon.css" />
                        <link rel="stylesheet" href="assets/css/index.css" />
                        <link rel="stylesheet" href="assets/css/modal-style.css" />
                        <link href="assets/css/material.css" rel="stylesheet" />
                        <link href="assets/css/bootstrap.min.css" rel="stylesheet" />
                        <link href="react-table-without-pagination.css" rel="stylesheet" />
                        <link href="assets/css/div-as-input-field.css" rel="stylesheet" />

                        <link rel="stylesheet" href="assets/css/custom-style.css" />
                        <link rel="stylesheet" href="assets/css/styles.css" />


                        {/* Navigation bar */}
                        <nav className="main-header navbar navbar-expand bg-white navbar-light border-bottom" id="nav" style={{ height: "75px", marginBottom: '0px' }}>

                            <img src="assets/images/dhee.png" style={{ height: "90px", width: "250px", marginRight: "0px" }} alt="AdminLTE Logo" className="brand-link" />

                            <ul className="navbar-nav ml-auto">

                                <li className="nav-item dropdown col-sm-2">
                                    <div class="dropdown">
                                        <span><img src="assets/images/help.svg" style={{ height: "20px", width: "20px", marginTop: '22px' }} /></span>
                                        <div class="dropdown-content">
                                            <a onClick={this.routeToHelpPage}>&nbsp;&nbsp;Documentation</a>
                                            <a onClick={this.showPreviousRaiseTicket} >&nbsp;Report an issue</a>

                                        </div>
                                    </div></li>
                                <li className="nav-item dropdown col-sm-2">
                                    <span><img title="My account" style={{ height: "20px", width: "20px", marginTop: '22px' }} src="assets/images/account.svg" /></span>
                                    <div class="dropdown-content" >
                                        <a onClick={this.showMyAcount}>&nbsp;My account</a>
                                        <a onClick={this.routeToInvoicePage}>&nbsp;Invoices</a>

                                    </div>
                                </li>
                                {/* Notifications Dropdown Menu */}
                                <li className="nav-item col-sm-2">
                                    <span><img title="Logout" onClick={() => this.setState({ hideLogoutConfirmation: true })} style={{ height: "40px", width: "40px", marginTop: '22px' }} src="./assets/images/power.svg" /></span>
                                </li>

                                <div id="outer-container" className="col-sm-2" style={{ marginTop: "22px", marginRight: "20%" }} >
                                    <Menu pageWrapId={"page-wrap"} outerContainerId="bubble" noOverlay right>
                                        <a style={{ textDecoration: 'none' }} id="conversational-ai" className="menu-item dhee-console-links" onClick={this.moveToConversationalAI}>Conversational AI Platform</a><br />

                                        <a id="cloud-asr" className="menu-item dhee-console-links" onClick={this.moveToSpeechPlatform}>Automatic Speech Recognition APIs</a><br />
                                        <a id="cloud-akshar" className="menu-item dhee-console-links" onClick={this.moveToAksharPlatform}>Text Transliteration APIs</a><br />
                                        <a id="cloud-tts" className="menu-item dhee-console-links" onClick={this.moveToTtsPlatform}>Text To Speech APIs</a><br />
                                    </Menu>
                                </div>

                            </ul>
                        </nav>
                        {/* end of navigation bar */}


                        <div className="content-header" >
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-5" style={{ marginLeft: '40px' }}>
                                        <h1 className="m-0 page-title">Projects</h1>
                                        <h6 className="taglineTxt">Manage Your Projects</h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="border-bottom" style={{ marginLeft: '60px', marginRight: '60px' }}></div>
                        <ToastContainer className="Toast-at-center" />
                        {/* button */}
                        <div className="row" style={{ marginBottom: '5px' }}>
                            <div className="col-sm-8">
                                <button type="button" className="btn btn-primary navyblue-btn" style={{ marginLeft: '65px', marginTop: '20px' }} onClick={() => window.location.href = '/sales-desk/projectmgmt'}>

                                    <span className="delereuserbtn">Cancel</span></button>
                            </div>

                            <div className="col-sm-4">
                                <div className="d-flex flex-row-reverse pt-2">
                                    <div className="p-2" style={{ marginRight: '50px' }}>
                                        <button type="button" className="btn btn-primary navyblue-btn" onClick={this.createNewProject}>
                                            <span className="delereuserbtn" align="left">Create New Project</span></button>
                                        <button className="btn action-button" title="Refresh project data"
                                            onClick={this.refreshProjectData}>
                                            <img src="./assets/images/refresh_white_24dp.png" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="content">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-lg-12 ">
                                        <div className="card" style={{ marginRight: '50px', marginLeft: '50px' }}>
                                            <div id="reactTable" className="table mangeClientTable text-center" >
                                                <div>
                                                    <ReactTable id='reactTable'
                                                        data={data}
                                                        columns={[{
                                                            Header: <b>Project Name</b>,
                                                            accessor: 'name',
                                                            minWidth: 17,
                                                            sortable: false,
                                                            Cell: props => (<div Align="left" className="input"
                                                                contentEditable={(props.original.id == null || props.original.name.trim() == "") ? true : (props.original.id == this.state.editedProjectId)}
                                                                suppressContentEditableWarning
                                                                type="text" id={"projectName1" + props.index} title={props.original.name}
                                                                style={{ padding: '8px', marginTop: "2%", borderBottom: 'none', border: (props.original.id == this.state.editedProjectId) ? '1px solid #D2D4DC' : 'none', borderRadius: (props.original.id == this.state.editedProjectId) ? '2px' : 'none', paddingLeft: '10px' }}
                                                            > {props.original.name}</div>
                                                            )
                                                        }, {
                                                            Header: <b>Description</b>,
                                                            accessor: 'projectDescription',
                                                            textAlign: 'screenLeft',
                                                            sortable: false,
                                                            minWidth: 50,
                                                            Cell: props => (<div Align="left" className="textarea"
                                                                contentEditable={(props.original.id == null || props.original.projectDescription.trim() == "") ? true : (props.original.id == this.state.editedProjectId)}

                                                                style={{ marginTop: "0px", marginBottom: "1%", backgroundColor: "#ffffff", padding: "10px", borderRadius: '4px', width: '98%', border: (props.original.id == undefined || props.original.id == this.state.editedProjectId) ? '1px solid #D2D4DC' : 'none', borderRadius: (props.original.id == undefined) ? '2px' : 'none', paddingLeft: '10px' }}
                                                                type="text" id={"projectDescription1" + props.index} name="desc"
                                                            > {props.original.projectDescription} </div>)
                                                        },
                                                        {
                                                            Header: <b>Domain</b>,
                                                            minWidth: 17,
                                                            accessor: 'domain',
                                                            sortable: false,
                                                            Cell: props => {
                                                                return (
                                                                    <div Align="left" style={{ marginTop: "4%", paddingLeft: '10px' }}
                                                                        contentEditable={false}
                                                                        suppressContentEditableWarning className="pro"
                                                                        type="text" id={"domainOption1" + props.index} name="domainOption1"
                                                                    > {props.original.domain} </div>
                                                                )
                                                            },
                                                        },
                                                        {
                                                            Header: <b>Actions</b>,
                                                            minWidth: 19,

                                                            Cell: props => {
                                                                return (

                                                                    <div Align="left" style={{ Align: "right" }}>

                                                                        {/* Edit/Save Button */}
                                                                        <button title={(props.original.projectDescription.trim() == "") || props.original.name.trim() == "" ? "save" : ((props.original.id != this.state.editedProjectId) ? "edit" : "save")}
                                                                            style={{ backgroundColor: "#ffffff", border: "none" }}>
                                                                            <img className="img-responsive"
                                                                                style={{ marginTop: (props.original.projectDescription.trim() == "") || props.original.name.trim() == "" ? '6px' : ((props.original.id != this.state.editedProjectId) ? '8px' : '6px'), backgroundColor: '#282a65', borderRadius: '5px', padding: '1px' }}
                                                                                src={(props.original.projectDescription.trim() == "") || props.original.name.trim() == "" ? this.saveImageSrc : ((props.original.id != this.state.editedProjectId) ? this.editImageSrc : this.saveImageSrc)}
                                                                                onClick={(e) => {
                                                                                    (props.original.id == this.state.editedProjectId) ? this.saveProjectApi(props, e)
                                                                                        :
                                                                                        this.editCell(props, e);

                                                                                }}
                                                                            />
                                                                        </button>
                                                                        {/* Delete Button*/}
                                                                        <button title="delete" style={{ backgroundColor: "#ffffff", border: "none" }}><img className="img-responsive" style={{ marginTop: '6px', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px' }} src={"./assets/images/baseline_delete_white_24dp.png"}
                                                                            onClick={(e) => {
                                                                                this.deleteSelectedProject(e, props)
                                                                            }
                                                                            } />
                                                                        </button>
                                                                        {/* Upgrade plan Button*/}
                                                                        <button className="btn2 table-action-button" onClick={(e) => { this.moveToPlansPage(props.original.id) }}>Upgrade plan</button>

                                                                    </div>
                                                                )
                                                            }
                                                        }]}
                                                        defaultPageSize={10}
                                                        pageSizeOptions={[5, 10, 15]} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div></div></div>


                        {/****************start of raise ticket and left menu modal***** */}
                        <div class="modal" id="myModal" style={{ display: this.state.showRaiseTicketPage ? 'block' : 'none', paddingTop: "0px" }}>
                            <div class="modal-dialog " id="center-aligned-ticket-modal">
                                <div class="modal-content" id="modal-content-body" style={{ height: "auto", width: "800px", padding: "0px" }}>

                                    <div class="modal-body">

                                        <div className="card-body p-0 mb-25">

                                            <div className="tab-content col-12 p-0">

                                                <div className="tab-pane active show" id="tab_1">
                                                    <div className="card card-primary mt-3">
                                                        <div class="modal-header noBorder">
                                                            <button type="button" class="close" data-dismiss="modal" onClick={this.closeRaiseTicketPage}>
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                                                    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                                                                    <path d="M0 0h24v24H0z" fill="none" />
                                                                </svg>
                                                            </button>

                                                        </div>
                                                        <form role="form" className="raiseTicketLable">

                                                            <div className="card-body raise-form">

                                                                <div className="form-group col-6 pull-left p-0">
                                                                    <label className="col-12 pull-left " htmlFor="Subject">Title</label>
                                                                    <input type="text" className="form-control col-11 raise-form-input" id="title" placeholder="Subject" />
                                                                </div>
                                                                <div className="form-group col-6 pull-left">
                                                                    <label className="col-12 pull-left ">Ticket Type</label>
                                                                    <div className="form-group col-md-12 pull-left selectOption p-0 reqTypeSelect">
                                                                        <select id="Ticket-type" className="form-control select2 " style={{ width: '100%' }} tabIndex={-1} aria-hidden="true">

                                                                        </select>
                                                                    </div>
                                                                </div>
                                                                <div className="form-group col-12 pull-left p-0">
                                                                    <label className="" htmlFor="exampleInputPassword2">Description</label>
                                                                    <textarea className="form-control raise-form-input" rows={3} placeholder="Enter Description .." defaultValue={""} id="description" />
                                                                </div>
                                                                <div className="form-group col-6 pull-left">
                                                                    <label className="col-12 pull-left " htmlFor="exampleInputPassword1">Ticket Status</label>
                                                                    <div className="form-group col-md-12 pull-left selectOption p-0 reqTypeSelect">
                                                                        <select id="Ticket-status" className="form-control select2 " style={{ width: '100%' }} tabIndex={-1} aria-hidden="true">

                                                                        </select>
                                                                    </div>
                                                                </div>
                                                                <div className="form-group col-6 pull-left">
                                                                    <label className="col-12 pull-left " htmlFor="exampleInputPassword1">Ticket Priority</label>
                                                                    <div className="form-group col-md-12 pull-left selectOption p-0 reqTypeSelect">
                                                                        <select id="Ticket-priority" className="form-control select2 " style={{ width: '100%' }} tabIndex={-1} aria-hidden="true">

                                                                        </select>
                                                                    </div>
                                                                </div>
                                                                <div className="form-group col-12 pull-left mt-1 p-0">
                                                                    <label className="col-12 pull-left " htmlFor="Subject">Attach File</label>
                                                                    <div className="custom-file">

                                                                        <input type="file" accept="image/x-png,image/jpeg" id="inputFile1" onChange={this.ticketfileChangedHandler} />
                                                                        <span> *Supports only ./png,./jpg formats </span>
                                                                    </div>
                                                                </div>
                                                                <div className="raise-form pull-left pt-3">
                                                                    <button type="button" style={{ width: "200px" }} className="btn pull-right navyblue-btn" onClick={this.submit}>Submit</button>
                                                                </div>
                                                            </div>
                                                        </form>
                                                    </div>
                                                </div>
                                            </div></div></div></div>

                            </div></div>
                        {/*************previous page */}
                        <div class="modal" id="myModal" style={{ display: this.state.showPreviousTicketPage ? 'block' : 'none' }}>
                            <div class="modal-dialog" id="center-aligned-modal">
                                <div class="modal-content" id="modal-content-body" style={{ height: "auto", width: "1200px", padding: "0px", backgroundColor: "#F9F9FB" }}>


                                    {/* <TrialIframe /> */}
                                    <div class="modal-header noBorder">
                                        <button type="button" class="close" title="close" data-dismiss="modal" onClick={this.closePreviousTicketPage}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                                <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                                                <path d="M0 0h24v24H0z" fill="none" />
                                            </svg>
                                        </button>

                                    </div>
                                    <div class="modal-body">


                                        <div className="row">
                                            <div className="col-sm-6 signinTitle">
                                                <h4 style={{ textAlign: 'right' }}>Ticket History</h4>
                                            </div>
                                            <div className="col-sm-3">
                                                <div Align="right">
                                                    <select id="Ticket-status-drop-down" className="form-control select2 " onChange={this.statushandlechange} style={{ width: '50%', marginTop: "12px" }} tabIndex={-1} aria-hidden="true">
                                                        <option value="false">OPEN</option>
                                                        <option value="true">CLOSED</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-sm-3">



                                                <div Align="right">

                                                    <button type="button" className="btn navyblue-btn" onClick={this.showRaiseTicket}>
                                                        <span className="delereuserbtn" >RaiseTicket</span></button>
                                                </div>
                                            </div>
                                        </div>


                                        <form>

                                            <div className="content">
                                                <div className="container-fluid">

                                                    <div className="row">
                                                        <div className="col-lg-3 ">
                                                            <div className="card">

                                                                <div >


                                                                    <ReactTable id='reactTable'
                                                                        data={this.state.ticketData}
                                                                        columns={[
                                                                            {
                                                                                Header: <b>Tickets</b>,
                                                                                accessor: 'title',
                                                                                overflow: "visible",
                                                                                sortable: false,
                                                                                Cell: props => (

                                                                                    <div Align="left" className="cursor-change" onClick={(e) => {
                                                                                        (props.original.id == this.state.editedId || (props.original.title.trim() == "") || props.original.description.trim() == "") ? this.saveTicketCell(props, e)
                                                                                            :
                                                                                            this.editTicketCell(props, e);

                                                                                    }} contentEditable={false}>
                                                                                        <div class="listContent userIdBox">
                                                                                            <div style={{ marginTop: "15px" }}
                                                                                                contentEditable={false}


                                                                                                suppressContentEditableWarning
                                                                                                type="text" id={"ticketTictle" + props.index}

                                                                                            > <b>{props.original.title === '' ? 'No Tickets Found' : props.original.title}</b></div></div>
                                                                                        <div class="listContent userIdBox">
                                                                                            <div style={{ marginTop: "15px" }}
                                                                                                contentEditable={false}


                                                                                                suppressContentEditableWarning
                                                                                                type="text" id={"ticketTictle" + props.index}

                                                                                            > {props.original.ticketType}</div>
                                                                                            <div style={{ marginTop: "15px", Align: "right", color: (props.original.ticketPriority === "CRITICAL") ? "red" : "orange" }}
                                                                                                contentEditable={false}


                                                                                                suppressContentEditableWarning
                                                                                                type="text" id={"ticketTictle" + props.index}

                                                                                            > {props.original.ticketPriority}</div>
                                                                                        </div></div>

                                                                                )
                                                                            }



                                                                        ]}
                                                                        showPagination={false}
                                                                        style={{ height: "400px" }}
                                                                        className="-highlight"
                                                                        defaultPageSize={this.state.ticketData.length}
                                                                        pageSize={this.state.ticketData.length}


                                                                    />
                                                                </div>
                                                            </div></div>
                                                        <div className="col-lg-9" style={{ backgroundColor: "#ffffff", height: "400px", overflowY: "scroll" }} >
                                                            <div className="card-body raise-form" style={{ backgroundColor: "#eff4f9" }}>




                                                                <div className="form-group col-6 pull-left p-0">

                                                                    <h2 className={this.state.ticketTitle == '' ? '' : "signinTitle cursor-change"} title="Click here to close or reopen ticket" onClick={this.showStatusClosePopup} style={{ textAlign: "left" }}>{this.state.ticketTitle === '' ? '' : this.state.ticketTitle}</h2>
                                                                    <h6>{this.state.ticketType}</h6><br />
                                                                    <h8>{this.state.ticketFileName}</h8>
                                                                    <DialogComponent width='400px' animationSettings={this.settings} header='Project' showCloseIcon={true} buttons={this.ticketStatusButton} ref={dialog => this.dialogInstance = dialog} visible={this.state.showTicketStatusPopup} close={this.dialogClose}><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />&nbsp;Do you want to close the ticket?
                                                                        Note: Press 'Yes' to &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Close or press 'No' to decline</DialogComponent>

                                                                    <DialogComponent width='400px' animationSettings={this.settings} header='Project' showCloseIcon={true} buttons={this.ticketStatusButton} ref={dialog => this.dialogInstance = dialog} visible={this.state.showTicketStatusOpenPopup} close={this.dialogClose}><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />&nbsp;Do you want to reopen the ticket?
                                                                        Note: Press 'Yes' to &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; reopen or press 'No' to decline</DialogComponent>

                                                                </div>
                                                                <div className="form-group col-6 pull-left" Align="Right">
                                                                    <h4 style={{ color: (this.state.ticketStatus === "OPEN") ? "green" : "red", marginTop: "1.5rem" }}>{this.state.ticketType === '' ? '' : this.state.ticketStatus + '|'}</h4><h8>{this.state.lastModifiedDate}</h8>
                                                                    <br /><br />
                                                                    <h8 style={{ color: (this.state.ticketPriority === "CRITICAL") ? "red" : "orange" }}>{this.state.ticketPriority}</h8>

                                                                </div>
                                                            </div>
                                                            <br />
                                                            <div id="reactTable" className="table mangeClientTable text-center">


                                                                <ReactTable id='reactTable'
                                                                    data={this.state.ticketInfo}
                                                                    columns={[
                                                                        {
                                                                            Header: <b>Comments</b>,
                                                                            accessor: 'comment',
                                                                            minWidth: 17,
                                                                            overflow: "visible",
                                                                            sortable: false,
                                                                            Cell: props => (<div class="direct-chat-msg " Align="left" >
                                                                                <div class="direct-chat-text chat_left" style={{ marginTop: "20px", backgroundColor: "#fbf7f7" }} var date={new Date(props.original.commentTime)}>
                                                                                    <b>{props.original.comment}</b>
                                                                                    <br />

                                                                                    {props.original.commentType === '' ? "" : props.original.commentType + ' ' + '|' + ' ' + props.original.commentTime}
                                                                                </div>
                                                                            </div>)
                                                                        }]}
                                                                    showPagination={false}
                                                                    style={{ height: (this.state.ticketInfo.length > 1) ? "280px" : "170px" }}
                                                                    defaultPageSize={this.state.ticketInfo.length}
                                                                    pageSize={this.state.ticketInfo.length}
                                                                />

                                                            </div>
                                                            <br />
                                                            <div className="form-group col-12 pull-left p-0">
                                                                <label className="" htmlFor="exampleInputPassword2" textColor="#007aff">Post your Comments</label>
                                                                <div className="row">
                                                                    <div className="col-sm-10">
                                                                        <textarea className="form-control raise-form-input" rows={3} placeholder="Post something here .." id="comment" style={{ width: "765px", position: "relative" }}></textarea>
                                                                        &nbsp;</div>
                                                                    <div className="col-sm-2">
                                                                        <div align="right">
                                                                            <button type="button" title="Submit" onClick={this.saveTicketCommentsApi} style={{ width: "200px",width: "74px", height: "74px", position: "relative" }}><img src="assets/images/submitArrow.svg" ></img></button>
                                                                        </div> </div>
                                                                </div>

                                                                <div className="raise-form pull-left pt-3">

                                                                </div>
                                                            </div></div>
                                                    </div></div>

                                            </div>
                                        </form>

                                    </div>
                                </div>
                            </div>
                        </div>

                        {/*-----------------------------------My Account Page Popup------------------------*/}

                        <div className="modal" style={{ display: this.state.showMyAcountPopUp ? 'block' : 'none' }}>
                            <div className="modal-dialog" id="center-aligned-account-modal">
                                <div className="modal-content" style={{ height: "600px", width: "900px" }}>
                                    <div className="modal-header noBorder">
                                        <button type="button" className="close" data-dismiss="modal" id="close_id" onClick={this.closeMyAccountPage}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24">
                                                <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                                                <path d="M0 0h24v24H0z" fill="none" />
                                            </svg>
                                        </button>
                                    </div>
                                    <div className="modal-body">
                                        <form ref={(el) => this.myFormRef = el}>
                                            <MyAccount />
                                        </form>
                                    </div>
                                </div>
                            </div>
                            <DialogComponent width='200px' style={{ position: "fixed" }} animationSettings={this.settings}
                                header='Log out?' showCloseIcon={true} buttons={this.logoutButton}
                                ref={dialog => this.dialogInstance = dialog}
                                visible={this.state.hideLogoutConfirmation} close={this.dialogClose}>
                                <img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                                    content="" />&nbsp;Are you sure you want to log out?</DialogComponent>
                        </div>

                        {/*-------------------------------------------------------------------------------------------------*/}
                        <div class="modal" id="myModal" style={{ display: this.state.showInvoiceManagePage ? 'block' : 'none' }}>
                            <div class="modal-dialog " id="center-aligned-invoice-modal">
                                <div class="modal-content" id="modal-content-body" style={{ height: "auto", width: "1100px", padding: "0px", backgroundColor: "#F9F9FB" }}>


                                    {/* <TrialIframe /> */}
                                    <div class="modal-header noBorder">



                                        <button type="button" class="close" title="close" data-dismiss="modal" onClick={this.closeInvoiceManagePage}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                                <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                                                <path d="M0 0h24v24H0z" fill="none" />
                                            </svg>
                                        </button>

                                    </div>
                                    <div class="modal-body">

                                        <div className="wrapper" style={{ height: "400px" }}>


                                            <link rel="stylesheet" href="assets/css/invoice-styles.css" />
                                            <link rel="manifest" href="%PUBLIC_URL%/manifest.json" />
                                            <link rel="shortcut icon" href="%PUBLIC_URL%/favicon.ico" />
                                            <div className="content">
                                                <div className="container-fluid">
                                                    <div className="row">

                                                        <div className="col-lg-3" style={{ flexBasis: "28%", maxWidth: "28%" }}>
                                                            <div className="primeclr" style={{ minHeight: "120px", borderRadius: "8px", border: "1px solid #282a65" }}>
                                                                <div className="pric_head" align="center">

                                                                    <h5 className="planTitle starter1" style={{ color: "#282a65" }}> Project Credits <br /> <br /><b style={{ color: "#008000" }}><i class="fa fa-inr"></i>&nbsp;{this.state.walletBalance}</b></h5>

                                                                </div>
                                                            </div>
                                                            <br />
                                                            <div className="card">

                                                                <div >


                                                                    <ReactTable id='reactTable'
                                                                        noDataText="Invoices will be created at the month end for your deployed agents and APIs"
                                                                        data={this.state.invoices}

                                                                        columns={[
                                                                            {
                                                                                Header: <b>Invoices for {(JSON.parse(localStorage.getItem("user_details")) != null) ? JSON.parse(localStorage.getItem("user_details"))["name"] : ""}</b>,
                                                                                accessor: 'paymentId',
                                                                                minWidth: 17,
                                                                                overflow: "visible",
                                                                                sortable: false,
                                                                                Cell: props => (

                                                                                    <div align="left" className="cursor-change" onClick={(e) => {
                                                                                        (props.original.id == this.state.editedInvoiceId) ? this.saveInvoice(props, e)
                                                                                            :
                                                                                            this.invoiceInfo(props, e);

                                                                                    }}>Invoice from {props.original.billingFromDate} to {props.original.billingToDate}</div>

                                                                                )
                                                                            }



                                                                        ]}
                                                                        showPagination={false}
                                                                        style={{ height: (this.state.invoices.length == 0) ? "240px" : "340px" }}
                                                                        className="-highlight"
                                                                        defaultPageSize={this.state.invoices.length}
                                                                        pageSize={(this.state.invoices.length == 0) ? 0 : 5}


                                                                    />
                                                                </div>
                                                            </div></div>


                                                        <div className="col-lg-9" style={{ flexBasis: "72%", maxWidth: "72%", display: this.state.displayInvoice ? 'block' : 'none' }}>
                                                            <div align="right">

                                                                <button className="btn navyblue-btn " style={{ height: "auto", width: "auto" }}
                                                                    onClick={() => { this.pdfExportComponent.save(); }}>
                                                                    Generate Pdf</button>
                                                            </div>
                                                            <PDFExport
                                                                paperSize="auto"
                                                                fileName="invoice.pdf"
                                                                ref={(component) => this.pdfExportComponent = component}
                                                                margin="2cm"
                                                            >
                                                                <div>
                                                                    <div className="card-body" style={{ paddingTop: "0.1rem" }}>
                                                                        <div className="row mb-4" >
                                                                            <div className="col-sm-8" >
                                                                                <img src="./assets/images/dheeCroppedImage.png" style={{ height: "90px", width: "250px", paddingLeft: "0px", paddingBottom: "0px" }} />
                                                                                <h3 className="mb-0"><b>Invoice</b> </h3><br />
                                                                                <h6>Invoice number:{this.state.editedInvoiceId}</h6>
                                                                            </div>
                                                                            <div className="col-sm-4">
                                                                                <div align="right">
                                                                                    <div><b>Dheeyantra Research Labs</b></div>

                                                                                    <div>www.dhee.ai</div>
                                                                                    <div>Phone: +91-99808-79343</div>

                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="card-body">
                                                                        <div className="row mb-4">
                                                                            <div className="col-sm-12">
                                                                                <h5><b>Bill to</b></h5>
                                                                                <div>{JSON.parse(localStorage.getItem("user_details")) != null ? JSON.parse(localStorage.getItem("user_details"))["name"] : ""}</div>
                                                                                <div>{JSON.parse(localStorage.getItem("user_details")) != null ? JSON.parse(localStorage.getItem("user_details"))["organizationName"] : ""}</div>
                                                                                <div>{JSON.parse(localStorage.getItem("user_details")) != null ? JSON.parse(localStorage.getItem("user_details"))["address"] : ""}</div>
                                                                                <div>{JSON.parse(localStorage.getItem("user_details")) != null ? JSON.parse(localStorage.getItem("user_details"))["emailId"] : ""}</div>
                                                                                <div>Phone: {JSON.parse(localStorage.getItem("user_details")) != null ? JSON.parse(localStorage.getItem("user_details"))["mobileNumber"] : ""}</div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="row">
                                                                            <div className="col-sm-4">
                                                                                <h5><b>Details</b></h5>
                                                                                <div>Invoice date..............{this.state.Date}</div>
                                                                                <div>Billing id....................{this.state.paymentId}</div>


                                                                            </div>
                                                                            <div className="col-sm-8">


                                                                                <div style={{ marginTop: "5px", marginBottom: "10px" }}><b>Summary for &nbsp; {this.state.billingFromDate} to {this.state.billingToDate}</b></div>
                                                                                <div className="border-bottom-1"></div>
                                                                                <div className="row">
                                                                                    <div className="col-sm-6">
                                                                                        <div style={{ marginTop: "10px", marginBottom: "10px" }}>Subtotal in INR</div>
                                                                                        <div style={{ marginTop: "5px", marginBottom: "10px" }}>Integrated GST(18%)</div>
                                                                                        <div style={{ marginTop: "5px", marginBottom: "10px" }}>Total in INR</div>
                                                                                    </div>
                                                                                    <div className="col-sm-6">
                                                                                        <div style={{ marginTop: "10px", marginBottom: "10px" }} align="right"><i class="fa fa-inr"></i> {Number(this.state.invoiceSubtotal).toFixed(4)} </div>
                                                                                        <div style={{ marginTop: "10px", marginBottom: "10px" }} align="right"><i class="fa fa-inr"></i> {Number(this.state.invoiceGst).toFixed(4)} </div>
                                                                                        <div style={{ marginTop: "10px", marginBottom: "10px", fontSize: "20px" }} align="right"><i class="fa fa-inr"></i> {Number(this.state.billingAmount).toFixed(2)}</div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <table id="customers" style={{ marginTop: "32px" }}>
                                                                                <tbody id="invoice-List">

                                                                                </tbody>
                                                                            </table>
                                                                        </div>

                                                                        <div className="row">

                                                                            <div className="col-lg-4 col-sm-5 ml-auto">
                                                                                <table id="customers" style={{ marginBottom: "30px" }}>
                                                                                    <tbody>

                                                                                        <tr>
                                                                                            <td className="left">
                                                                                                <strong className="text-dark">Total</strong> </td>
                                                                                            <td className="right">
                                                                                                <strong className="text-dark" style={{ fontSize: "20px", fontFamily: "dejavu-sans" }}><i class="fa fa-inr"></i> {this.state.billingAmount}</strong>
                                                                                            </td>
                                                                                        </tr>
                                                                                    </tbody>
                                                                                </table>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="card-footer bg-white">
                                                                        Tax should not be deducted on the GST component charged on the invoice as per circular no. 23 of 2017 dated 19 July 2017 issued by
                                                                        the Central Board of Direct Taxes, Ministry of Finance, Govt of India.<br />
                                                                        Note: Unless otherwise stated, tax on this invoice is not payable under reverse charge. Supplies under reverse charge are to be
                                                                        mentioned separately.

                                                                    </div>
                                                                </div>
                                                            </PDFExport>
                                                        </div>
                                                    </div>


                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/*Dialog Component For Updation Success*/}
                        <DialogComponent width='400px' animationSettings={this.settings}
                            header='Project' showCloseIcon={true} buttons={this.buttons}
                            ref={dialog => this.dialogInstance = dialog}
                            visible={this.state.hideDeletePopup} close={this.dialogClose}>
                            <img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                                content="" />&nbsp;Do you want to delete the Project?&nbsp;
                            Note: Press 'Yes' to delete or press 'No' to decline.</DialogComponent>
                    </div>
                </div>
            </div>

        );
    }
}

export default ManagePro;


// WEBPACK FOOTER //
// ./src/sales-desk/header/ManagePro.js